/* basic. custom interaction events. Shopify remains the consent authority. */
(function () {
  'use strict';
  if (window.BasicConversionAnalytics) return;

  var QUIZ_VERSION = 'swipe-2026-10-v1';
  var SCHEMA_VERSION = '1';
  var ARTICLE_HANDLES = ['deodorant-le-plus-efficace', 'deodorant-wild-avis-test-honnete-alternative-suisse-2026'];
  var COLLECTION_HANDLES = ['all', 'deodorants', 'visage', 'corps', 'cheveux', 'baume-a-levres', 'huiles'];
  var privacyRequested = false;
  var schemas = {
    'basic:quiz_start': ['quiz_version', 'question_count'],
    'basic:quiz_step': ['quiz_version', 'step_index', 'question_count'],
    'basic:quiz_complete': ['quiz_version', 'question_count', 'recommendation_count'],
    'basic:quiz_recommendation_click': ['quiz_version', 'product_handle'],
    'basic:cart_drawer_opened': ['location', 'item_count', 'currency', 'value'],
    'basic:article_product_click': ['article_handle', 'product_handle'],
    'basic:collection_product_click': ['collection_handle', 'product_handle']
  };

  function protectedHandle(handle) {
    return /(^|-)kit(?:-|$)|^le-rose(?:-|$)/.test(handle);
  }

  function protectedPage() {
    var path = window.location && window.location.pathname || '';
    var match = path.match(/\/products\/([^/]+)/);
    try { return !!(match && protectedHandle(decodeURIComponent(match[1]))); }
    catch (error) { return true; }
  }

  function requestPrivacyApi() {
    var shopify = window.Shopify;
    if (privacyRequested || shopify && shopify.customerPrivacy) return;
    if (!shopify || typeof shopify.loadFeatures !== 'function') return;
    privacyRequested = true;
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) privacyRequested = false;
      });
    } catch (error) {
      privacyRequested = false;
    }
  }

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() === true);
    } catch (error) {
      return false;
    }
  }

  function validValue(key, value) {
    if (key === 'quiz_version') return value === QUIZ_VERSION;
    if (key === 'location') return value === 'cart_drawer';
    if (key === 'currency') return typeof value === 'string' && /^[A-Z]{3}$/.test(value);
    if (key === 'article_handle') return ARTICLE_HANDLES.indexOf(value) !== -1;
    if (key === 'collection_handle') return COLLECTION_HANDLES.indexOf(value) !== -1;
    if (key === 'product_handle') return typeof value === 'string' && value.length <= 100 &&
      /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value) && !protectedHandle(value);
    if (key === 'value') return typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 10000000;
    return typeof value === 'number' && Number.isInteger(value) && value >= (key === 'step_index' ? 1 : 0) &&
      value <= (key === 'item_count' ? 10000 : 200);
  }

  function linkedProduct(link) {
    try {
      var href = link.getAttribute('href');
      if (!href) return null;
      var url = new URL(href, document.baseURI);
      if (url.origin !== window.location.origin) return null;
      var page = url.pathname.split('/').pop();
      var routes = window.BasicShopify && window.BasicShopify.productRoutes;
      if (routes && Object.prototype.hasOwnProperty.call(routes, page) && routes[page]) {
        url = new URL(routes[page], window.location.origin);
      }
      if (url.origin !== window.location.origin) return null;
      var match = /\/products\/([a-z0-9-]+)\/?$/.exec(url.pathname);
      return match ? match[1] : null;
    } catch (error) { return null; }
  }

  function trackProductClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var articleLink = target.closest('a.basic-article-choice');
    if (articleLink) {
      var article = articleLink.closest('[data-basic-article-source]');
      var articleProduct = linkedProduct(articleLink);
      if (article && articleProduct && articleLink.dataset.basicArticleChoice === articleProduct) {
        track('basic:article_product_click', {
          article_handle: article.dataset.basicArticleSource, product_handle: articleProduct
        });
      }
      return;
    }
    var collectionLink = target.closest('.basic-conversion-collection a.catalogue-card');
    if (!collectionLink) return;
    var collection = /\/collections\/([a-z0-9-]+)\/?$/.exec(window.location.pathname);
    var collectionProduct = linkedProduct(collectionLink);
    if (collection && collectionProduct) {
      track('basic:collection_product_click', {
        collection_handle: collection[1], product_handle: collectionProduct
      });
    }
  }

  function track(name, payload) {
    if (!Object.prototype.hasOwnProperty.call(schemas, name)) return false;
    var fields = schemas[name];
    if (!fields || !payload || typeof payload !== 'object' || protectedPage()) return false;
    var safe = { schema_version: SCHEMA_VERSION };
    for (var index = 0; index < fields.length; index += 1) {
      var key = fields[index];
      if (!validValue(key, payload[key])) return false;
      safe[key] = payload[key];
    }
    if (name === 'basic:quiz_step' && safe.step_index > safe.question_count) return false;
    requestPrivacyApi();
    if (!analyticsAllowed()) return false;
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return false;
    try {
      var result = analytics.publish(name, safe);
      // Publication is best effort. A pixel outage must never break an interaction.
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return result !== false;
    } catch (error) {
      return false;
    }
  }

  // No cookies, storage, identity, answer data, event queue or Google tag here.
  window.BasicConversionAnalytics = Object.freeze({ track: track });
  if (!protectedPage()) {
    document.addEventListener('click', trackProductClick);
    requestPrivacyApi();
    document.addEventListener('DOMContentLoaded', requestPrivacyApi, { once: true });
    window.addEventListener('load', requestPrivacyApi, { once: true });
  }
})();
